<mat-dialog-content>
    <fieldset>
        <table>
            <tr>
                <td><label>Inventory ID:</label></td>
                <td>{{source.stockItem.InventoryID}}</td>
                <td rowspan="2"><item-thumbnail [item]="source.stockItem" [size]="50"></item-thumbnail></td>
            </tr>
            <tr *ngIf="source.LotSerialNbr">
                <td><label>Lot/Serial #:</label></td>
                <td>{{source.LotSerialNbr}}</td>
            </tr>
            <tr>
                <td colspan="3">
                    <label>Match:&nbsp;</label><mat-button-toggle-group name="commercialMatch"
                        [value]="source.CommercialMatch" (change)="commercialMatchToggleChange($event, source)">
                        <mat-button-toggle [value]="null"><mat-icon>help</mat-icon></mat-button-toggle>
                        <mat-button-toggle [value]="false"><mat-icon>remove</mat-icon></mat-button-toggle>
                        <mat-button-toggle [value]="true"><mat-icon>check</mat-icon></mat-button-toggle>
                    </mat-button-toggle-group>
                </td>
            </tr>
        </table>

        <inventory-adjustment-editor #inventoryAdjustment [inventory]="source"
            (onEnterKey)="focusRestockLocation()"></inventory-adjustment-editor>

        <inventory-location-editor #restockLocationComponent [inventory]="source"
            [warehouseLocations]="warehouseLocations" [suffixTemplate]="printerSuffix"
            (onLocationEntered)="pieceRestocked($event)"></inventory-location-editor>

        <input type="hidden" scanInput="PTR" (scanned)="onPrinterScanned($event)" />
    </fieldset>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button mat-dialog-close="hold" color="accent">Hold for Restock</button>
    <button mat-raised-button mat-dialog-close="cancel" color="accent">Cancel</button>
    <!-- <button mat-raised-button (click)="okButtonClick()" color="primary">OK</button> -->
</mat-dialog-actions>

<ng-template #printerSuffix>
    <mat-icon>print</mat-icon>
</ng-template>